import { useState } from "react";
import { ArrowRight, Check } from "lucide-react";
import { api } from "@/lib/api";

/**
 * NewsletterForm — raccolta email newsletter.
 * Prop `dark`: variante per sfondi scuri (footer).
 * Prop `testidPrefix`: prefisso dei data-testid.
 */
export default function NewsletterForm({ dark = false, testidPrefix = "newsletter" }) {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle"); // idle | loading | done | error

  const submit = async (e) => {
    e.preventDefault();
    if (!email || state === "loading") return;
    setState("loading");
    try {
      await api.post("/newsletter/subscribe", { email });
      setState("done");
    } catch {
      setState("error");
    }
  };

  if (state === "done") {
    return (
      <p
        data-testid={`${testidPrefix}-success`}
        className={`flex items-start gap-3 text-sm font-medium leading-relaxed ${dark ? "text-[#FAC075]" : "text-[#323C36]"}`}
      >
        <span className={`mt-0.5 w-6 h-6 rounded-full flex items-center justify-center shrink-0 ${dark ? "bg-[#FAC075] text-[#2A3229]" : "bg-[#323C36] text-[#F6F3EF]"}`}>
          <Check size={13} />
        </span>
        Iscrizione confermata: da questa settimana, una cosa concreta su cui lavorare per migliorare la tua impresa.
      </p>
    );
  }

  return (
    <form data-testid={`${testidPrefix}-form`} onSubmit={submit} className="w-full">
      <div className="flex flex-col sm:flex-row gap-3">
        <input
          data-testid={`${testidPrefix}-input`}
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="La tua email"
          aria-label="La tua email"
          className={dark
            ? "flex-1 bg-transparent border border-[#F6F3EF]/25 px-5 py-3.5 text-sm text-[#F6F3EF] placeholder-[#F6F3EF]/40 outline-none focus:border-[#FAC075] transition-colors"
            : "flex-1 bg-white border border-[#323C36]/15 px-5 py-4 text-sm text-[#2A3229] placeholder-[#5A6058]/60 outline-none focus:border-[#323C36] transition-colors"}
        />
        <button
          data-testid={`${testidPrefix}-submit`}
          type="submit"
          disabled={state === "loading"}
          className="btn-accent justify-center whitespace-nowrap disabled:opacity-60"
        >
          {state === "loading" ? "Iscrizione…" : <>Iscriviti <ArrowRight size={15} /></>}
        </button>
      </div>
      {state === "error" && (
        <p data-testid={`${testidPrefix}-error`} className={`mt-3 text-sm ${dark ? "text-[#FAC075]" : "text-[#A8674F]"}`}>
          Qualcosa non ha funzionato. Riprova tra poco.
        </p>
      )}
    </form>
  );
}
